import { Box, Divider } from '@mui/material';
import { IconCross } from 'assets/img';
import { Header, LwFormDate, LwFormInput, LwFormSelect, LwIconButton } from 'redesign';

type FormHeaderSectionProps = {
  title: string;
  subtitle: string;
  control: any;
  minDate: string;
  onClose: () => void;
};

export const FormHeaderSection = ({
  title,
  subtitle,
  control,
  minDate,
  onClose,
}: FormHeaderSectionProps) => (
  <Box mb={4}>
    <Box display="flex" alignItems="baseline" justifyContent="space-between">
      <Header titleText={title} subheaderText={subtitle} />
      <LwIconButton iconColorMode="stroke" color="secondary" onClick={onClose}>
        <IconCross width={24} height={24} />
      </LwIconButton>
    </Box>
    <Box display="flex" gap={2} alignItems="center">
      <LwFormDate
        name="utcStartDate"
        label="Startdatum"
        control={control}
        rules={{ required: 'Voer een startdatum in' }}
        minDate={minDate}
      />
      <LwFormSelect
        name="employmentType"
        rules={{ required: true }}
        label="Dienstverband"
        options={[
          { value: 'FREELANCER', label: 'Zelfstandige' },
          { value: 'TEMPWORKER', label: 'Uitzendkracht' },
        ]}
        control={control}
        sx={{ width: '40%' }}
      />
      <LwFormInput name="name" rules={{ required: true }} label="Naam ORT" control={control} />
      <LwFormSelect
        name="surchargeType"
        rules={{ required: true }}
        label="Surcharge Type"
        options={[{ value: 'factor', label: '%' }]}
        control={control}
        sx={{ width: '40%' }}
      />
    </Box>
    <Divider />
  </Box>
);
